import { useState, useEffect } from "react";

export function useDebouncedValue<T>(input: T, time = 500): T {
  const [debouncedValue, setDebouncedValue] = useState(input);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setDebouncedValue(input);
    }, time);
    return (): void => {
      clearTimeout(timeout);
    };
  }, [input, time]);

  return debouncedValue;
}
